import "../css/header.scss";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { FaBars, FaShoppingCart } from "react-icons/fa";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const cartItemCount = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  return (
    <header className="site-header">
      <div className="header-top">
        <div className="header-top-content">
          <p>Free shipping on orders over $150</p>
        </div>
      </div>
      <div className="header-main">
        <div className="container">
          <button
            type="button"
            className="mobile-menu-toggle"
            aria-label="Toggle navigation"
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen((open) => !open)}
          >
            <FaBars />
          </button>
          <Link to="/" className="logo" onClick={toTop}>
            <span className="logo-mark" aria-hidden="true">T</span>
            <span className="logo-wordmark">tugglefield</span>
          </Link>

          <nav className={`main-nav ${mobileMenuOpen ? "active" : ""}`}>
            <Link
              to="/"
              onClick={() => {
                toTop();
                setMobileMenuOpen(false);
              }}
            >
              Home
            </Link>
            <Link
              to="/shop"
              onClick={() => {
                toTop();
                setMobileMenuOpen(false);
              }}
            >
              Shop
            </Link>
            <Link
              to="/about"
              onClick={() => {
                toTop();
                setMobileMenuOpen(false);
              }}
            >
              About
            </Link>
            <Link
              to="/contact"
              onClick={() => {
                toTop();
                setMobileMenuOpen(false);
              }}
            >
              Contact
            </Link>
            <div className={`nav-more ${moreOpen ? "open" : ""}`}>
              <button
                type="button"
                className="nav-more__toggle"
                aria-expanded={moreOpen}
                aria-controls="more-menu"
                onClick={() => setMoreOpen((open) => !open)}
              >
                More <span aria-hidden="true">⌄</span>
              </button>
              <div className="nav-more__menu" id="more-menu">
                {[
                  ["Privacy Policy", "/privacy"],
                  ["Terms of Service", "/terms"],
                  ["Shipping Policy", "/shipping"],
                  ["Returns Policy", "/returns"],
                  ["FAQs", "/faqs"],
                  ["Cookie Policy", "/cookies"],
                ].map(([label, path]) => (
                  <Link
                    key={path}
                    to={path}
                    onClick={() => {
                      toTop();
                      setMoreOpen(false);
                      setMobileMenuOpen(false);
                    }}
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>
          </nav>

          <div className="header-actions">
            <Link to="/cartpage" className="cart-btn" onClick={toTop}>
              <FaShoppingCart />
              {cartItemCount > 0 && (
                <span className="cart-count">{cartItemCount}</span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
